import React from "react"
import loadable from "@loadable/component"

const CarouselComponent = loadable(() =>
  import("../CarouselImages/CarouselComponent")
)

export const CarouselSection = ({
  classTitle,
  trim,
  width,
  cover,
  images,
  s1920,
  s1366,
  s1024,
  s768,
  s640,
  s360,
}) => {
  return (
    <div
      className={`info-${classTitle}-detalles-carousel`}
      data-sal="slide-up"
      data-sal-delay="200"
      data-sal-easing="ease"
    >
      <CarouselComponent
        trim={trim}
        width={width}
        cover={cover}
        images={images}
        s1920={s1920}
        s1366={s1366}
        s1024={s1024}
        s768={s768}
        s640={s640}
        s360={s360}
      />
    </div>
  )
}
